import { ReactElement, ReactNode } from 'react';
import cn from 'classnames';
import styles from './Container.module.scss';

export interface ContainerProps {
  className?: string;
  children?: ReactNode;
  el?: string;
  clean?: boolean;
  /** Opts out of the fixed 1264/1360px width, keeping just a responsive gutter. */
  fullWidth?: boolean;
}

const Container = ({
  children,
  className,
  el = 'div',
  clean,
  fullWidth,
}: ContainerProps): ReactElement => {
  const rootClassName = cn(
    {
      [styles.containerBase]: !clean && !fullWidth,
      [styles.fullWidthGutter]: fullWidth,
    },
    className
  );

  const Component: React.ComponentType<React.HTMLAttributes<HTMLDivElement>> =
    el as any;

  return <Component className={rootClassName}>{children}</Component>;
};

export default Container;
